import * as zanalytics from '@zillow/universal-analytics';
import type { AppProps } from 'next/app';
import { GlobalStyle } from '../styles/globalStyles';
import { HeadBase } from '@zg-rentals/next-components';
import { getCmsInfoForPage } from '@zillow/zrs-cms';
import { RpErrorBoundary, useBootstrap } from '@zg-rentals/rp-bootstrap-browser';
import { useEffectOnce } from 'react-use';
import { trackExposureEvent } from '../utils/trackExposureEvent';

const MyApp = ({ Component, pageProps }: AppProps) => {
  useBootstrap(() => import('../bootstrap/browser'));

  const isProd = process.env.NEXT_PUBLIC_ENV === 'prod';

  useEffectOnce(() => {
    // on Prod, we already initialize zanalytics from pfs
    if (!isProd) {
      const options = {
        zillow: {
          apiKey: isProd ? 'z_prod' : 'z_test',
          apiHost: isProd ? 'e.zg-api.com' : 'analytics-zg-api.test.zillow.net',
          secure: true,
          writeKey: isProd ? 'zrm_prod_web' : 'zrm_dev_web',
        },
      };

      zanalytics.initZanalytics(window, document, options, 'zanalytics');
    }

    zanalytics.page(
      window.location.pathname,
      {},
      {
        newLaneEvent: {
          envelope: {
            event_type_id: '2284',
            event_type_version_id: '1',
            event_template_id: '126',
            event_template_version_id: '1',
            event_client_start_dtm: new Date().toISOString(),
          },
          clickstream_trigger: {
            trigger_type_nm: 'view',
            trigger_location_nm: 'cms',
            trigger_source_nm: 'cms',
            trigger_object_nm: 'no_trigger_object',
          },
          semantic: {
            semantic_event_nm: 'view_content',
          },
          // @ts-ignore
          cms_info: getCmsInfoForPage(pageProps),
        },
      },
    );

    trackExposureEvent();
  });

  return (
    <>
      <HeadBase applicationName="zrm-marketing-web" buildNumber={process.env.NEXT_PUBLIC_BUILD_NUMBER}>
        {process.env.NEXT_PUBLIC_OPTIMIZELY_ID && (
          <>
            <link
              rel="preload"
              href={`https://www.zillowstatic.com/optimizely/${process.env.NEXT_PUBLIC_OPTIMIZELY_ID}.js`}
              as="script"
            />
            <link rel="preconnect" href="//logx.optimizely.com" />
            <script src={`https://www.zillowstatic.com/optimizely/${process.env.NEXT_PUBLIC_OPTIMIZELY_ID}.js`} />
            <link
              rel="prefetch"
              href={`https://www.zillowstatic.com/optimizely/${process.env.NEXT_PUBLIC_OPTIMIZELY_ID}.js`}
              as="script"
            />
          </>
        )}
      </HeadBase>

      <GlobalStyle />
      <RpErrorBoundary>
        <Component {...pageProps} />
      </RpErrorBoundary>
    </>
  );
};

export default MyApp;
